export const ExpertStream = "EXPERT";
export const TechnicianStream = "TECHNICIAN";
export const ShareScreen ="SHARESCREENSTREAMING"